import axios from "axios";

const ROOT_URL = process.env.VUE_APP_API_URL;

export default {
  rootUrl: ROOT_URL,
  getData(secondUrl) {
    return axios.post(`${ROOT_URL}/${secondUrl}`, {
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });
  },

  login(loginCredentials, secondUrl) {
    return axios.post(`${ROOT_URL}/${secondUrl}`, loginCredentials, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  register(regCredentials, secondUrl) {
    return axios.post(`${ROOT_URL}/${secondUrl}`, regCredentials, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  logout(token) {
    return axios.get(`${ROOT_URL}/logout`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  fetchAllData(token, apiUrl, fundingStatusId) {
    return axios.get(`${ROOT_URL}/${apiUrl}/${fundingStatusId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  fetchData(token, apiUrl) {
    return axios.get(`${ROOT_URL}/${apiUrl}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  storeData(token, secondUrl, storeData) {
    return axios.post(`${ROOT_URL}/${secondUrl}`, storeData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  updateData(token, id, updateData, secondUrl) {
    // console.log(updateData);
    return axios.put(`${ROOT_URL}/${secondUrl}/${id}`, updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  deleteData(token, secondUrl, item) {
    return axios.delete(`${ROOT_URL}/${secondUrl}/${item}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  deleteAll(token, secondUrl) {
    return axios.delete(`${ROOT_URL}/${secondUrl}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  getFundingList(token, apiUrl, fundingStatusId) {
    return axios.get(`${ROOT_URL}/${apiUrl}/${fundingStatusId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  changeInvestorDataStatus(token, itemId, apiUrl) {
    return axios.get(`${ROOT_URL}/${apiUrl}/${itemId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  changeDataStatus(
    token,
    loanProductId = null,
    apiUrl,
    statusId,
    search,
    currentPage,
    per_page,
    reject_reason = null
  ) {
    if (reject_reason === null || reject_reason === undefined) {
      return axios.get(
        `${ROOT_URL}/${apiUrl}${
          loanProductId !== null ? `/${loanProductId}` : ""
        }/${statusId}?query=${search}&page=${currentPage}&per_page=${per_page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
    }
    // For rejected loan request
    return axios.get(
      `${ROOT_URL}/${apiUrl}/${statusId}?query=${search}&page=${currentPage}&per_page=${per_page}&reason=${reject_reason}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },

  getIndexDataByPagination(token, apiUrl, search, currentPage, per_page) {
    return axios.get(
      `${ROOT_URL}/${apiUrl}?query=${search}&page=${currentPage}&per_page=${per_page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },

  downloadFile(apiUrl) {
    let token = window.localStorage.getItem("shadhin_token");
    return axios.get(`${ROOT_URL}/${apiUrl}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      responseType: "blob",
    });
  },
};
